import { IItemCustomization } from "@faire/web-api--source/indigofair/data/IItemCustomization";

export const getCustomizationsMapFromItemCustomizations = (
  customizations: IItemCustomization[]
) => {
  const map = new Map<string, string>();

  customizations.forEach((customization) => {
    if (
      customization.product_customization_token !== undefined &&
      customization.value !== undefined
    ) {
      map.set(customization.product_customization_token, customization.value);
    }
  });

  return map;
};

export const copyCustomizationWithoutTokenAndAdditionalCharge = (
  customization: IItemCustomization | undefined
): IItemCustomization | undefined => {
  if (!customization) {
    return undefined;
  }

  return IItemCustomization.build({
    product_customization_token: customization.product_customization_token,
    type: customization.type,
    value: customization.value,
  });
};
